import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();

    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#050505]">
                <div className="hg-eyebrow text-[#22C55E] animate-pulse">
                    // Verifying session…
                </div>
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    return children;
}
